import { ModuleWithProviders, NgModule } from '@angular/core';
import { CheckoutCostCenterAdapter, CheckoutCostCenterConnector } from '@spartacus/checkout/b2b/core';
import { OccCheckoutCostCenterAdapter } from '@spartacus/checkout/b2b/occ';
import { CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root';
import { CheckoutStepsSetGuard } from '@spartacus/checkout/base/components';
import { CheckoutDeliveryAddressConnector, CheckoutDeliveryModesConnector, CheckoutPaymentConnector } from '@spartacus/checkout/base/core';
import { CheckoutDeliveryAddressEventListener, CheckoutEventModule } from '@spartacus/checkout/base/root';
import { PageMetaResolver } from '@spartacus/core';
import { CustomCheckoutPageMetaResolver } from '../../../../../services/product/custom-checkout-page-meta.resolver';
import { CustomCheckoutDeliveryAddressEventListener } from '../../../cms-components/checkout/guards/custom-checkout-delivery-address-event.listener';
import { CustomCheckoutStepsSetGuard } from '../../../cms-components/checkout/guards/custom-checkout-steps-set.guard';
import { CustomPaymentTypeService } from './facade/custom-payment-type.service';
import { interceptors } from './http-interceptors';
import { CustomCheckoutOccModule } from './occ/custom-checkout-occ.module';
import { CustomCheckoutStoreModule } from './store/custom-checkout-store.module';

@NgModule({
  imports: [
    CustomCheckoutStoreModule,
    CheckoutEventModule,
    CustomCheckoutOccModule
  ],
  providers: [
    { provide: CheckoutPaymentTypeFacade, useClass: CustomPaymentTypeService }
  ]
})
export class CustomCheckoutModule {
  static forRoot(): ModuleWithProviders<CustomCheckoutModule> {
    return {
      ngModule: CustomCheckoutModule,
      providers: [
        ...interceptors,
        CheckoutDeliveryAddressConnector,
        CheckoutDeliveryModesConnector,
        CheckoutPaymentConnector,
        CheckoutCostCenterConnector,
        {
          provide: PageMetaResolver,
          useExisting: CustomCheckoutPageMetaResolver,
          multi: true,
        },
        {
          provide: CheckoutCostCenterAdapter,
          useClass: OccCheckoutCostCenterAdapter,
        },
        {
          provide: CheckoutStepsSetGuard,
          useClass: CustomCheckoutStepsSetGuard
        },
        {
          provide: CheckoutDeliveryAddressEventListener,
          useClass: CustomCheckoutDeliveryAddressEventListener
        }
      ],
    };
  }
}
